import _styled from "styled-components";
import React from "react";
import { Link } from "react-router-dom";

var Container = _styled.div.withConfig({
  displayName: "Menu__Container",
  componentId: "sc-1oien3g-0"
})(["display:flex;flex-direction:column;width:100%;min-height:100%;pointer-events:auto;"]);

var IconContainer = _styled.div.withConfig({
  displayName: "Menu__IconContainer",
  componentId: "sc-1oien3g-1"
})(["display:flex;flex-direction:column;align-items:center;svg,figure,png{width:60px;height:60px;@media screen and (max-width:419px){width:40px;height:40px;}}"]);

var IconLabel = _styled.div.withConfig({
  displayName: "Menu__IconLabel",
  componentId: "sc-1oien3g-2"
})(["margin-top:10px;font-size:20px;"]);

var StyledLink = _styled(Link).withConfig({
  displayName: "Menu__StyledLink",
  componentId: "sc-1oien3g-3"
})(["flex:1;max-height:150px;min-height:120px;display:flex;flex-direction:column;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(255,255,255,0);&,&:hover,&:active{color:black;text-decoration:none;}&:focus,&:active{outline:0 none;}@media screen and (max-width:419px){max-height:120px;min-height:100px;}"]);

export function Menu(_ref) {
  var menuApi = _ref.menuApi,
      menu = _ref.menu;
  return /*#__PURE__*/React.createElement(Container, null, menu.map(function (_ref2) {
    var path = _ref2.path,
        title = _ref2.title,
        Icon = _ref2.Icon,
        _onClick = _ref2.onClick;
    return /*#__PURE__*/React.createElement(StyledLink, {
      key: path,
      to: path,
      onClick: function onClick(event) {
        menuApi.close();

        if (_onClick) {
          _onClick(event);
        }
      }
    }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement(IconLabel, null, title)));
  }));
}